import { CustomCard } from "@/components";
import { IBrandWithChildren } from "@/models";
import { RouteNames } from "@/router";
import { Component, Vue, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";

@Component({
    components: {
        CustomCard,
        draggable,
    },
})
export default class Brands extends Vue {
    public RouteNames = RouteNames;

    public filterText = "";

    public currentPage = 1;

    public itemsPerPage = 100;

    public filteredBrands: IBrandWithChildren[] = [];

    public slicedBrands: IBrandWithChildren[] = [];

    public get brands(): IBrandWithChildren[] {
        return this.$store.getters["app/brands"]?.sort((a,b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }

    @Watch("filterText")
    watchFitlerText(value): void {
        this.currentPage = 1;
        this.computeFilteredBrands(value);
    }

    @Watch("filteredBrands")
    handleFilteredBrands(): void {
        this.doPrepareSlicedBrands();
    }

    @Watch("currentPage")
    handleCurrentPage(): void {
        this.doPrepareSlicedBrands();
    }

    @Watch("itemsPerPage")
    handleItemsPerPage(): void {
        this.doPrepareSlicedBrands();
    }

    computeFilteredBrands(filterText = this.filterText): void {
        if (filterText != null && filterText.length > 0) {
            this.filteredBrands = this.brands.filter(curr => {
                return curr.name.startsWith(filterText) || curr.children.some(child => child.name.startsWith(filterText));
            });
            return;
        }
        this.filteredBrands = this.brands;
    }


    doPrepareSlicedBrands(): void {
        this.slicedBrands = this.filteredBrands.slice(
            (this.currentPage - 1) * this.itemsPerPage,
            (this.currentPage - 1) * this.itemsPerPage + this.itemsPerPage,
        );
    }

    get numberOfPages(): number {
        const result = this.filteredBrands.length / this.itemsPerPage;

        if (result > Math.floor(result)) return Math.floor(result) + 1;

        return result;
    }

    async mounted(): Promise<void> {
        await this.$store.dispatch("app/loadAllBrand");
        this.computeFilteredBrands();
        this.doPrepareSlicedBrands();
    }
}
